export const showAnimateMobile = ref => {
  if (ref.current.children[0]) {
    [...ref.current.children].forEach((_, index) => {
      setTimeout(() => {
        ref.current.children[index].classList.add('will-show-animate');
      }, 150);
      return null;
    });
  } else {
    setTimeout(() => {
      ref.current.classList.add('will-show-animate');
    }, 150);
  }
};
